export default __webpack_public_path__ + "static/media/template_pro__0019_8---TimofeyKuz.6a58f3bf.png";